import { useEffect, useEffectEvent } from 'react'

const EVENT = 'beacon:tab-reselect'

// Dispatched synchronously inside the tap handler, so a listener that calls
// input.focus() still counts as user-initiated and raises the iOS keyboard.
export function emitTabReselect(pathname: string) {
  window.dispatchEvent(new CustomEvent<string>(EVENT, { detail: pathname }))
}

export function useTabReselect(pathname: string, onReselect: () => void) {
  const handle = useEffectEvent(onReselect)

  useEffect(() => {
    const listener = (e: Event) => {
      if ((e as CustomEvent<string>).detail === pathname) handle()
    }
    window.addEventListener(EVENT, listener)
    return () => window.removeEventListener(EVENT, listener)
  }, [pathname])
}
